import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { BellIcon, CalendarDaysIcon, FolderOpenIcon, HomeIcon, LogOutIcon, UserIcon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { Logo } from '../ui/Logo';
import { Avatar } from '../ui/Avatar';
import { Toasts } from '../ui/Toasts';
const nav = [{
  to: '/clan',
  label: 'Domov',
  icon: HomeIcon,
  end: true
}, {
  to: '/clan/dogodki',
  label: 'Dogodki',
  icon: CalendarDaysIcon,
  end: false
}, {
  to: '/clan/obvestila',
  label: 'Obvestila',
  icon: BellIcon,
  end: false
}, {
  to: '/clan/gradiva',
  label: 'Gradiva',
  icon: FolderOpenIcon,
  end: false
}, {
  to: '/clan/profil',
  label: 'Profil',
  icon: UserIcon,
  end: false
}];
export function MemberLayout() {
  const {
    currentMember,
    announcements,
    logout
  } = useApp();
  const navigate = useNavigate();
  const neprebrana = currentMember ? announcements.filter(a => a.prejemniki.includes(currentMember.id) && !a.prebrali.includes(currentMember.id)).length : 0;
  return <div className="flex min-h-full w-full flex-col bg-canvas" data-id="element-273" data-mp="3vkryq3xvogb8">
      <header className="sticky top-0 z-30 border-b border-line bg-white/95 backdrop-blur" data-id="element-274" data-mp="3qp2u3m704982">
        <div className="mx-auto flex h-16 w-full max-w-5xl items-center justify-between gap-4 px-4 sm:px-6" data-id="element-275" data-mp="8atvtuzj90u6">
          <NavLink to="/clan" className="flex items-center gap-3" aria-label="VIVA Portal — domov" data-id="element-276" data-mp="3iaagbult1et">
            <Logo className="h-9" data-id="element-277" data-mp="i6ontgpnc89m" />
            <span className="hidden text-sm font-semibold text-ink sm:block" data-id="element-278" data-mp="i9symwxma299">VIVA Portal</span>
          </NavLink>

          <nav className="hidden items-center gap-1 md:flex" aria-label="Glavna navigacija" data-id="element-279" data-mp="r8ebqckbkp2n">
            {nav.map(n => <NavLink key={n.to} to={n.to} end={n.end} className={({
            isActive
          }) => `relative rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-150 ease-out ${isActive ? 'bg-green-50 text-green-700' : 'text-ink-muted hover:bg-canvas hover:text-ink'}`} data-id="element-280" data-mp="n6t00ujiugu1">
                {n.label}
                {n.label === 'Obvestila' && neprebrana > 0 && <span className="ml-1.5 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-purple-500 px-1 text-[10px] font-semibold text-white" data-id="element-281" data-mp="11v68tfqatgdv">
                    {neprebrana}
                  </span>}
              </NavLink>)}
          </nav>

          <div className="flex items-center gap-2" data-id="element-282" data-mp="1fufrcm1z8ml0">
            {currentMember && <button onClick={() => navigate('/clan/profil')} className="flex items-center gap-2 rounded-lg px-1.5 py-1 transition-colors duration-150 ease-out hover:bg-canvas" aria-label="Odpri profil" data-id="element-283" data-mp="1kniby4os0lp2">
                <Avatar member={currentMember} size="sm" data-id="element-284" data-mp="1ylytyrs39ymi" />
                <span className="hidden text-sm font-medium text-ink lg:block" data-id="element-285" data-mp="1ymi0lccah0l8">
                  {currentMember.ime}
                </span>
              </button>}
            <button onClick={() => {
            logout();
            navigate('/');
          }} aria-label="Odjava" className="rounded-lg p-2 text-ink-muted transition-colors duration-150 ease-out hover:bg-canvas hover:text-ink" data-id="element-286" data-mp="3f1mdvyel31gz">
              <LogOutIcon className="h-4 w-4" data-id="element-287" data-mp="6lud7n0k75y4" />
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-5xl flex-1 px-4 pb-28 pt-5 sm:px-6 md:pb-12" data-id="element-288" data-mp="1p40n9nyqshg">
        <Outlet data-id="element-289" data-mp="3t15nywqygmvx" />
      </main>

      <nav aria-label="Glavna navigacija" className="fixed inset-x-0 bottom-0 z-30 border-t border-line bg-white pb-[env(safe-area-inset-bottom)] md:hidden" data-id="element-290" data-mp="3t0dr7ilmgj42">
        <ul className="grid grid-cols-5" data-id="element-291" data-mp="pey8tdxc7svd">
          {nav.map(n => <li key={n.to} data-id="element-292" data-mp="klly87phtmlm">
              <NavLink to={n.to} end={n.end} className={({
            isActive
          }) => `flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors duration-150 ease-out ${isActive ? 'text-green-600' : 'text-ink-muted'}`} data-id="element-293" data-mp="klc6ofosv7dt">
                <span className="relative" data-id="element-294" data-mp="6lu9xbi3nsl">
                  <n.icon className="h-5 w-5" data-id="element-295" data-mp="7n8gantcqej" />
                  {n.label === 'Obvestila' && neprebrana > 0 && <span className="absolute -right-1.5 -top-1 h-2 w-2 rounded-full bg-purple-500" data-id="element-296" data-mp="su86ftyso0r2" />}
                </span>
                {n.label}
              </NavLink>
            </li>)}
        </ul>
      </nav>

      <Toasts data-id="element-297" data-mp="j33tt0wlcrze" />
    </div>;
}